import Flickity from 'flickity';
import $ from 'jquery';

$(document).ready(function () {
    document.querySelectorAll('.wp-block-talentvault-tabs').forEach((tabBlock: Element) => {

        const sliderContainer = tabBlock.querySelector('.wp-block-talentvault-tabs__tabs-content');
        if (sliderContainer) {
            const flkty = new Flickity(sliderContainer, {
                draggable: false,
                pageDots: false,
                prevNextButtons: false,
                contain: true,
                cellAlign: 'left',
            });

            window.addEventListener('load', function () {
                flkty.resize();
            });

            tabBlock.querySelectorAll('.wp-block-talentvault-tabs__tab')
                .forEach((header: HTMLElement) => {
                    header.addEventListener('click', () => {
                        const clickedTabId = header.getAttribute('data-tab-id');
                        flkty.selectCell(`.tab_${clickedTabId}`);

                        tabBlock.querySelectorAll('.wp-block-talentvault-tabs__tab').forEach(header => {
                            const tabId = header.getAttribute('data-tab-id');

                            if (tabId === clickedTabId) {
                                header.classList.add('wp-block-talentvault-tabs__tab--active');
                            } else {
                                header.classList.remove('wp-block-talentvault-tabs__tab--active');
                            }
                        });
                    });
                });
        }
    });
});
